import DefaultTreatmentPlan from './variants/Default';
import Plan from './variants/Treatment';
const SanityTreatmentPlan = Plan;
export { SanityTreatmentPlan };
export default DefaultTreatmentPlan;
